<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">快递物流说明</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">快递物流说明</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p class="font16">
                            一、夜樱情趣商城合作快递：圆通快递、韵达快递
                        </p>
                        <!-- <p><br></p>
                        <p class="font16">
                            二、全国主要城市送达时间预估：顺丰快递（1-3天），中通快递（2-4天），邮政EMS（2-5天）
                        </p>
                        <p><br></p>
                        <p class="font16">
                            三、目前夜樱情趣商城已与顺丰快递达成战略合作，并建立了七大仓库，包括：北京仓、江苏仓、广州仓、重庆仓、西安仓、武汉仓、大连仓；基本覆盖全国主要重点城市，七大仓库所覆盖地区，最快可一日送达；
                        </p>
                        <p><br></p>
                        <p class="font16">
                            四、订单金额满99元首选顺丰，顺丰快递不到的地方会根据实际情况选择最适合的快递公司。
                        </p> -->
                        <p><br></p>
                        <p class="font16">
                            二、如有特别送达需求可与商城客服及时沟通，我们会在第一时间为您解决问题。
                        </p>
                        <p><br></p>
                        <p class="font16">
                            <strong>特别说明：</strong>
                        </p>
                        <p class="font16">
                            （1）液体、膏体商品因禁止空运，陆运需要1至4天送达。
                        </p>
                        <p class="font16">
                            （2）部分中小城市，因为需要中转，所以需要4天或者6天。
                        </p>
                        <p class="font16">
                            （3）时限从发货时起算，因受限于快递公司服务或天气影响，倘若不能按时到货，感谢理解。
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p class="font16">
                        <a href="/help/qianshou" style="float:left;">上一篇:签收说明</a>
                        <a href="/help/kefu" class="pl10" style="float:right">下一篇:夜樱情趣商城客服</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font16{font-size: 16px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/wuliu.vue